var render = function render(){var _vm=this,_c=_vm._self._c;return _c('dol-select',{attrs:{"value":_vm.value,"source":"server","server-type":"DotNet","dot-net-table-name":"GM_CITY","label-field":_vm.$kt('CITY_NAME'),"key-field":"CITY_ID","value-field":"CITY_ID","query-data":_vm.queryData},on:{"input":_vm.inputValue,"change":_vm.changeValue}})
}
var staticRenderFns = []

export { render, staticRenderFns }